import { Link } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useClientId } from "@/features/clients/detail/use-client-id";
import { QuotationsPage } from "@/features/quotations/quotations-page";

export function ClientQuotationsPage() {
  const clientId = useClientId();
  return (
    <div className="space-y-3">
      <div className="flex justify-end">
        <Button asChild size="sm">
          <Link to="/quotations/new" search={{ client: clientId }}>
            <Plus />
            New quotation
          </Link>
        </Button>
      </div>
      <QuotationsPage clientId={clientId} embedded />
    </div>
  );
}
